import React, { Component } from 'react';
import ReactHlsPlayer from 'react-hls-player';
import * as encryptUtils from "./encryptDecryptUtils";
import * as loggingUtils from "./utils/loggingUtils";

const LivestreamsContainer = React.memo(props => {
  const onVODPlay = (livestreamURL) => {
    loggingUtils.logEvent(
      props.account != null
        ? props.account.address
        : encryptUtils.getWalletUnconnectedUserId(),
      "streamer_profile",
      "streamer_profile_vod_play",
      "info",
      "https://the402.xyz",
      {
        livestreamURL: livestreamURL,
      }
    );
  }

  return (
    <div className="flex w-screen items-center justify-center">
      <div className="grid grid-cols-1 xl:grid-cols-3 xl:gap-2 lg:grid-cols-2 lg:gap-4 w-11/12 mt-8 justify-center bg-custom-white dark:bg-custom-black flex">
        {
          props.livestreamURLs.map((livestreamURL, ind) => {
            if(!props.shouldShowLiveStreamForPastVods[ind]) {
              return (
                <img
                  key={ind}
                  className="cursor-pointer sm:hover:-translate-y-0 sm:hover:scale-105 duration-500 object-contain bg-black h-72 w-112 rounded-none sm:rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.4)]"
                  src={props.livestreamURLPreviews[ind]}
                />
              );
            }
            if(livestreamURL.includes("m3u8")) {
              return (
                <ReactHlsPlayer
                  key={ind}
                  className="cursor-pointer sm:hover:-translate-y-0 sm:hover:scale-105 duration-500 object-contain bg-black h-72 w-112 rounded-none sm:rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.4)]"
                  src={livestreamURL}
                  onPlay={() => onVODPlay(livestreamURL)}
                  controls={true}
                  width="100%"
                  height="auto"
                  hlsConfig={{
                    liveSyncDurationCount: 1
                  }}
                />
              );
            } else {
              return (
                <video
                  key={ind}
                  className="cursor-pointer sm:hover:-translate-y-0 sm:hover:scale-105 duration-500 object-contain bg-black h-72 w-112 rounded-none sm:rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.4)]"
                  src={livestreamURL}
                  onPlay={() => onVODPlay(livestreamURL)}
                  loop
                  autoplay="autoplay"
                  controls
                  muted
                >
                </video>
              );
            }
          })
        }
      </div>
    </div>
  );
});

export default LivestreamsContainer;
